import CompanyInformation from "@/views/settings/admin/CompanyInformation";
import Permissions from "@/views/settings/admin/Permissions";
import TrackerRoles from "@/views/settings/admin/TrackerRoles";
import DashboardSettings from "@/views/settings/admin/DashboardSettings";


export default [
    {
        path: '/admin',
        component: Permissions,
        meta: {
            access: ['enterprise'],
            onlyAdmin: true,
            title: 'Admin'
        }
    },
    {
        path: '/admin/company-info',
        component: CompanyInformation,
        meta: {
            access: ['enterprise'],
            onlyAdmin: true,
            title: 'Company Information'
        }

    },
    {
        path: '/admin/permissions',
        component: Permissions,
        meta: {
            access: ['enterprise'],
            onlyAdmin: true,
            title: 'Permissions'
        }
    },
    {
        path: '/admin/tracker-roles',
        component: TrackerRoles,
        meta: {
            access: ['enterprise'],
            onlyAdmin: true,
            title: 'Tracker Roles'
        }
    },
    {
        path: '/admin/dashboard-settings',
        component: DashboardSettings,
        meta: {
            access: ['enterprise'],
            onlyAdmin: true,
            title: 'Dashboard Settings'
        }
    },
]